import request from '@/utils/request'

const processApi = {
  addOrUpdateVolunteer: '/auth/online/addOrUpdateVolunteer', // 新增系统成员
  delVolunteer: '/auth/online/delVolunteer', // 删除系统成员
  volunteer: '/auth/online/volunteer', // 查询系统成员
  volunteerForPage: '/auth/online/volunteerForPage', //
  saveUser: '/auth/online/saveUser', // 创建用户
  updateUser: '/auth/online/updateUser', // 更新用户
  userForPage: '/auth/online/userForPage', // 查询用户
  delUser: '/auth/online/delUser', // 删除用户
  user: '/auth/online/user', // 查询用户
  getMunicipalTreeById: '/auth/online/getMunicipalTreeById', // 获取市级树单个节点
  updateMunicipalTreeById: '/auth/online/updateMunicipalTreeById', // 修改市级树单个节点
  municipalTree: '/auth/online/municipalTree' // 获取组织树
}

export function updateMunicipalTreeById(parameter) {
  return request({
    url: processApi.updateMunicipalTreeById,
    method: 'post',
    data: parameter
  })
}

export function getMunicipalTreeById(parameter) {
  return request({
    url: processApi.getMunicipalTreeById,
    method: 'post',
    data: parameter
  })
}

export function municipalTree(parameter) {
  return request({
    url: processApi.municipalTree,
    method: 'post',
    data: parameter
  })
}

export function addOrUpdateVolunteer(parameter) {
  return request({
    url: processApi.addOrUpdateVolunteer,
    method: 'post',
    data: parameter
  })
}

export function delVolunteer(parameter) {
  return request({
    url: processApi.delVolunteer,
    method: 'post',
    data: parameter
  })
}

export function volunteer(parameter) {
  return request({
    url: processApi.volunteer,
    method: 'post',
    data: parameter
  })
}
export function saveUser(parameter) {
  return request({
    url: processApi.saveUser,
    method: 'post',
    data: parameter
  })
}
export function updateUser(parameter) {
  return request({
    url: processApi.updateUser,
    method: 'post',
    data: parameter
  })
}
export function userForPage(parameter) {
  return request({
    url: processApi.userForPage,
    method: 'post',
    data: parameter
  })
}
export function user(parameter) {
  return request({
    url: processApi.user,
    method: 'post',
    data: parameter
  })
}
export function delUser(parameter) {
  return request({
    url: processApi.delUser,
    method: 'post',
    data: parameter
  })
}
export function volunteerForPage(parameter) {
  return request({
    url: processApi.volunteerForPage,
    method: 'post',
    data: parameter
  })
}
